import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React, { useState } from "react";
import { handleChangeHeader } from "../../../../../utils/commonFunctions/fieldCapitalize";
import { pink } from "@mui/material/colors";
import { firstFieldAppealsList_v2, secondFieldAppealsList_v2 } from "../../../../../constants/fieldsList/FieldsList";
import { AppealSelectColumnHeadersProps } from "../../../../../@types/appealReportAllprops.types";

const AppealSelectColumnHeaders: React.FC<AppealSelectColumnHeadersProps> = ({
	key,
	selectedColumns,
	handleUpdateSelectedColumns,
	appealsIDRTrackersCommonUnion,
	handleAppealsIDRTrackersCommonUnionChange
}) => {
	const [showAppeals, setShowAppeals] = useState(Boolean(appealsIDRTrackersCommonUnion.appeals));

	const [union, setUnion] = useState<boolean | null>(
		appealsIDRTrackersCommonUnion.appeals == "common"
			? false
			: appealsIDRTrackersCommonUnion.appeals == "union"
			? true
			: null
	);

	const handleSetUnionCChange = () => {
		console.log(union);
		if (union) {
			handleAppealsIDRTrackersCommonUnionChange("appeals", "common");
			setUnion(false);
		} else {
			handleAppealsIDRTrackersCommonUnionChange("appeals", "union");
			setUnion(true);
		}
	};

	const handleShowAppealsChange = () => {
		// console.log("hi");
		if (showAppeals) {
			setUnion(null);
			handleAppealsIDRTrackersCommonUnionChange("appeals", null);
			setShowAppeals(!showAppeals);
		} else {
			setUnion(true);
			handleAppealsIDRTrackersCommonUnionChange("appeals", "union");
			setShowAppeals(!showAppeals);
		}
	};
	return (
		<div>
			<div
				style={{
					width: "100%",
					margin: "auto",
					textAlign: "center",
					fontWeight: "bolder",
					color: "#ab455c",
					fontSize: "20px",
					marginBottom: "10px"
				}}
			>
				Appeals
				<Checkbox
					checked={showAppeals}
					sx={{
						color: pink[800],
						"&.Mui-checked": { color: pink[600] }
					}}
					onChange={(event: any) => handleShowAppealsChange()}
				/>
			</div>
			{showAppeals && (
				<div style={{ textAlign: "center", marginBottom: "20px" }}>
					<Grid item xs={12}>
						<FormControlLabel
							control={
								<Checkbox
									checked={union === true}
									onChange={(e: any) => handleSetUnionCChange()}
									sx={{
										color: pink[800],
										"&.Mui-checked": { color: pink[600] }
									}}
								/>
							}
							label="Union"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={union === false}
									onChange={(e: any) => handleSetUnionCChange()}
									sx={{
										color: pink[800],
										"&.Mui-checked": { color: pink[600] }
									}}
								/>
							}
							label="Common"
						/>
					</Grid>
				</div>
			)}
			{showAppeals && (
				<div className="fieldContainer">
					<Grid container spacing={4}>
						{[firstFieldAppealsList_v2, secondFieldAppealsList_v2].map((fieldList, columnIndex) => (
							<Grid item xs={12} sm={12} md={6} key={columnIndex}>
								<Grid container style={{ marginBottom: "1rem", color: "#ab455c", fontWeight: "bold" }}>
									<Grid item xs={6}>
										FIELD NAME
									</Grid>
									<Grid item xs={6} style={{ textAlign: "center" }}>
										View
									</Grid>
								</Grid>
								{fieldList.map((field, index) => (
									<Grid container key={index} style={{ marginBottom: "1rem" }} alignItems="center">
										<Grid item xs={6}>
											{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
										</Grid>
										<Grid item xs={6} style={{ textAlign: "center" }}>
											<Checkbox
												checked={selectedColumns.appeals[field]}
												sx={{
													color: pink[800],
													"&.Mui-checked": { color: pink[600] }
												}}
												onChange={(event: any) =>
													handleUpdateSelectedColumns(field, event.target.checked, "appeals")
												}
											/>
										</Grid>
									</Grid>
								))}
							</Grid>
						))}
					</Grid>
				</div>
			)}
		</div>
	);
};

export default AppealSelectColumnHeaders;
